import * as React from 'react';
import strings from 'owa-strings/owa-tasks-strings';
import { ActionButton } from 'office-ui-fabric-react/lib/Button';
import { ControlIcons } from 'owa-control-icons';

const styles = require('./LinkedEmailEntity.scss');

export interface LinkedEmailEntityProps {
    emailId: string;
    onClick: (emailId: string) => void;
}

export default class LinkedEmailEntity extends React.Component<LinkedEmailEntityProps, {}> {
    render() {
        return (
            <ActionButton
                className={styles.viewEmailButton}
                onClick={this.viewEmail}
                text={strings.viewEmail}
                iconProps={{
                    iconName: ControlIcons.Mail,
                    className: styles.emailIcon,
                }}
            />
        );
    }

    private viewEmail = () => {
        this.props.onClick(this.props.emailId);
    };
}
